@if (loading()) {
<pm-loading />
} @else if (error()) {
<pm-error-message />
} @else {
<div class="pm-form-field-container">
  @if (!formField.inlineLabel && !formField.hideLabel) {
  <pm-form-field-label [formField]="formField" [ctrl]="ctrl" />
  }
  <div class="pm-form-field">
    @if (formField.inlineLabel && !formField.hideLabel) {
    <div class="inline-label">{{ formField.label }}</div>
    }
    <div [ngSwitch]="formField.type">
      <div *ngSwitchCase="FormFieldTypeEnum.TEXT">
        <pm-form-field-text
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div>
      <div *ngSwitchCase="FormFieldTypeEnum.LONG_TEXT">
        <pm-form-field-long-text
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div>

      <div *ngSwitchCase="FormFieldTypeEnum.PASSWORD">
        <pm-form-field-password
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div>
      <div *ngSwitchCase="FormFieldTypeEnum.RADIO_TILE">
        <pm-form-field-radio-tile
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div>
      <div *ngSwitchCase="FormFieldTypeEnum.AUTOCOMPLETE">
        <pm-form-field-autocomplete
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div>
      <div *ngSwitchCase="FormFieldTypeEnum.TIME">
        <pm-form-field-time
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div>
      <div *ngSwitchCase="FormFieldTypeEnum.NUMBER">
        <pm-form-field-number
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div>
      <div *ngSwitchCase="FormFieldTypeEnum.RADIO">
        <pm-form-field-radio
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div>
      <div *ngSwitchCase="FormFieldTypeEnum.SWITCH">
        <pm-form-field-switch
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div>
      <div *ngSwitchCase="FormFieldTypeEnum.CHECKBOX">
        <pm-form-field-checkbox
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div>
      <div *ngSwitchCase="FormFieldTypeEnum.PHONE">
        <pm-form-field-phone
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div>
      <!-- <div *ngSwitchCase="FormFieldTypeEnum.PICKER">
        <pm-form-field-picker
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div> -->
      <div *ngSwitchCase="FormFieldTypeEnum.SLIDER">
        <pm-form-field-slider
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div>
      <div *ngSwitchCase="FormFieldTypeEnum.INPUT_OTP">
        <pm-form-field-input-otp
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div>
      <div *ngSwitchCase="FormFieldTypeEnum.CUSTOM_INPUT_OTP">
        <pm-form-field-custom-input-otp
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div>
      <div *ngSwitchCase="FormFieldTypeEnum.SELECT">
        <pm-form-field-select
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div>
      <div *ngSwitchCase="FormFieldTypeEnum.DATE">
        <pm-form-field-date
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
          (monthChanged)="onMonthChanged($event)"
        />
      </div>
      <div *ngSwitchCase="FormFieldTypeEnum.TOGGLE_SELECT">
        <pm-form-field-toggle-select
          [formField]="formField"
          [ctrl]="ctrl"
          #formFieldComponent
        />
      </div>
    </div>
  </div>
</div>

<pm-form-field-hint [ctrl]="ctrl" [formField]="formField" />
@if (!hideError && !formField.hideError) {
<pm-form-field-error [ctrl]="ctrl" [formField]="formField" />
} }
